<template>
  <svg
    class="guidance-overlay__line"
    :style="{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 10001, pointerEvents: 'none' }"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :d="pathD"
      fill="none"
      stroke="rgba(255,255,255,0.85)"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
}

const props = defineProps<Props>();

const pathD = computed(() => {
  const dx = props.toX - props.fromX;
  const dy = props.toY - props.fromY;

  const cx1 = props.fromX + dx * 0.1;
  const cy1 = props.fromY + dy * 0.6;
  const cx2 = props.fromX + dx * 0.4;
  const cy2 = props.fromY + dy * 0.9;

  return `M ${props.fromX} ${props.fromY} C ${cx1} ${cy1}, ${cx2} ${cy2}, ${props.toX} ${props.toY}`;
});
</script>
